import dayjs from 'dayjs';

// Nghỉ trưa cố định 12h-14h (2 tiếng) — chỉ trừ đúng phần thời gian làm việc
// thực sự trùng với khung giờ này, để không trừ sai cho ca chỉ làm buổi sáng
// hoặc chỉ làm buổi chiều.
const LUNCH_BREAK_START_HOUR = 12;
const LUNCH_BREAK_END_HOUR = 14;

export const getTotalWorkHours = (gioVaoRaw, gioRaRaw) => {
    if (!gioVaoRaw || !gioRaRaw) return null;
    const vao = dayjs(gioVaoRaw);
    const ra = dayjs(gioRaRaw);
    const diff = ra.diff(vao, 'hour', true);
    if (diff < 0) return null;

    const lunchStart = vao.hour(LUNCH_BREAK_START_HOUR).minute(0).second(0).millisecond(0);
    const lunchEnd = vao.hour(LUNCH_BREAK_END_HOUR).minute(0).second(0).millisecond(0);
    const overlapStart = vao.isAfter(lunchStart) ? vao : lunchStart;
    const overlapEnd = ra.isBefore(lunchEnd) ? ra : lunchEnd;
    const lunchOverlapHours = Math.max(0, overlapEnd.diff(overlapStart, 'hour', true));

    return Math.max(0, diff - lunchOverlapHours);
};
